<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  @import "../report.less";
  .margin-left20{ margin-left: 20px; }
  b{ color: red; }
</style>
<style lang="less">
  .report{
    .ivu-table-border td:nth-child(5) .ivu-table-cell,
    .ivu-table-border td:nth-child(6) .ivu-table-cell{
      padding:0;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding:10px;
      }
    }
  }
</style>
<template>
  <div class="report">
    <h3 class="title">缴费报表</h3>
    <div class="margin-bottom-10 header-group">
      <label>周期设置</label>
      <Select class="margin-left10" v-model="d_date_type" @on-change="change_type">
        <Option value="日">日度</Option>
        <Option value="月">月度</Option>
      </Select>
      <DatePicker :value="d_search_date"
                  :clearable="false"
                  type="date"
                  placeholder="选择日期"
                  style="width: 200px"
                  @on-change="change_date"></DatePicker>
      <!--<div class="right">-->
        <!--<span class="margin-left20">已开票余额: <b>{{ d_kaiyu}}</b> 元</span>-->
        <!--<span class="margin-left20">未开票余额: <b>{{ d_weiyu}}</b> 元</span>-->
        <!--<span class="margin-left20">未开票账户发生额: <b>{{ d_weifa}}</b> 元</span>-->
      <!--</div>-->
    </div>
    <section>
      <Table :columns="d_columns" :data="d_data_self" border disabled-hover></Table><br>
      <Table :columns="d_columns" :data="d_data_instead" border disabled-hover :show-header=false></Table><br>
    </section>
  </div>
</template>
<script>
  import apiReport from '@/api/report.js';
  export default {
    name:'costReport',
    data() {
      return {
        d_columns:[
          {
            title: '大项',
            key: 'TypeBig',
            minWidth:160,
            align: 'center'
          },
          {
            title: '小项',
            key: 'XiaoXiang',
            minWidth:160,
            align: 'center'
          },
          {
            title: '当期收款',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Dqsk+'元')
            }
          },
          {
            title: '当期退款',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Dqtk+'元')
            }
          },
          {
            title: '预交冲抵',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Yjcd+'元')
            }
          },
          {
            title: '当期开票收入',
            minWidth:150,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Dqkpsr+'元')
            }
          },
          {
            title: '税率',
            align: 'center',
            minWidth:120,
            render: (h, params) => {
              if('TaxRate' in params.row){
                return h('span',params.row.TaxRate+'%')
                }
            }
          },
          {
            title: '不含税价',
            minWidth:120,
            align: 'center',
            key:'Bhsj',
            render: (h, params) => {
              return h('span',(params.row.Bhsj).toFixed(2)+'元')
            }
          },
          {
            title: '应缴增值税',
            minWidth:120,
            align: 'center',
            key:'Yjzzs',
            render: (h, params) => {
              if('TaxRate' in params.row){
                return h('span',(params.row.Yjzzs).toFixed(2)+'元')
              }
            }
          },
          {
            title: '预收账款',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Yszk+'元')
            }
          },
          {
            title: '预收退款',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Ystk+'元')
            }
          },
          {
            title: '预收收入',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Yssr+'元')
            }
          },
          {
            title: '实收金额',
            minWidth:120,
            align: 'center',
            render: (h, params) => {
              return h('span',params.row.Ssje+'元')
            }
          }
        ],
        d_date_type: '',
        d_kaiyu:0,
        d_weiyu:0,
        d_weifa:0,
        d_search_date: this.to_date(new Date()),
        d_data_self: [],
        d_data_instead: [],
        d_all_type_obj:{
          self:[],
          agent:[]
        }
      };
    },
    methods: {
      to_date(date){
        let moment = require('moment');
        return moment(date).format('YYYY-MM-DD');
      },
      change_date(date){
        this.d_search_date = date;
        this.pull_data();
      },
      change_type(){
        this.pull_data();
      },
      sort_data(_type,_value){
        if(_type==='self'){
          switch (_value) {
            case '商铺租金':return 1;break;
            case '车位租金':return 2;break;
            case '土地租金':return 3;break;
            case '其他租金':return 4;break;
            case '管理费':  return 5;break;
            case '临时费用':return 6;break;
            case '违约金':  return 7;break;
            case '罚没收入':return 8;break;
            case '其他费用':return 9;break;
          }
        }else {
          switch (_value) {
            case '履约保证金':return 1;break;
            case '水电保证金':return 2;break;
            case '水费':return 3;break;
            case '电费':return 4;break;
            case '气费':  return 5;break;
            case '垃圾处理费':return 6;break;
          }
        }

      },
      getSummaries(param,name) {
        const { columns, data } = param;
        const sums = {};
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[column.property] = name;
            return;
          }
          if (index === 1) {
            sums[column.property] = '类型';
            return;
          }
          const values = data.map(item => Number(item[column.property])); //分组获取第一列的所有数据
          if (!values.every(value => isNaN(value))) {
            sums[column.property] = values.reduce((prev, curr) => { //循环加起来赋值给当前属性
              const value = Math.abs(curr);//负数的符号只是标志着退款或者收款，不做正负数计算2019-10-10
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
//            sums[column.property] += ' 元';
          } else {
            sums[column.property] = 'N/A';
          }
        });

        return sums;
      },
      pull_data() {
        let _this = this;
        apiReport.GetReport3(this.d_date_type,this.d_search_date).then((_data) => {
          //------
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            this.d_data_self = [];
            this.d_data_instead = [];
            if (requestResult.length<=0) return;
            let rowListSelf = [],rowListInstead = [];
            let rowList = requestResult.DetailList;
            this.d_kaiyu = requestResult.Kaiyu;
            this.d_weiyu = requestResult.Weiyu;
            this.d_weifa = requestResult.Weifa;
            let arrObj = {
              TypeBig:'',
              XiaoXiang:'',
              Dqsk:0,
              Dqtk:0,
              Yjcd:0,
              Dqkpsr:0,
              Bhsj:0,
              Yjzzs:0,
              Yszk:0,
              Ystk:0,
              Yssr:0,
              Ssje:0,
              TaxRate:0
            };
            let typeSelfArr = this.d_all_type_obj.self;
            let typeInsteadArr = this.d_all_type_obj.agent;
            let typeArr = typeSelfArr.concat(typeInsteadArr);
            let rowListType = [];
            for(let i=0;i<rowList.length;i++){
              if(rowListType.indexOf(rowList[i].XiaoXiang)<=-1){
                rowListType.push(rowList[i].XiaoXiang)
              }
              if(typeSelfArr.indexOf(rowList[i].XiaoXiang)>-1){
                rowList[i].TypeBig = '自收类费用';
                rowList[i].sortIndex = this.sort_data('self',rowList[i].XiaoXiang)
                rowListSelf.push(rowList[i]);
              }else{
                rowList[i].TypeBig = '代收类费用';
                rowList[i].sortIndex = this.sort_data('instead',rowList[i].XiaoXiang)
                rowListInstead.push(rowList[i]);
              }
            }

            for(let item of typeArr){
              if(rowListType.indexOf(item)<=-1){ //数据里面没有的一些分类
                if(typeSelfArr.indexOf(item)>-1){
                  rowListSelf.push({
                    TypeBig:'自收类费用',
                    XiaoXiang:item,
                    Dqsk:0,
                    Dqtk:0,
                    Yjcd:0,
                    Dqkpsr:0,
                    Bhsj:0,
                    Yjzzs:0,
                    Yszk:0,
                    Ystk:0,
                    Yssr:0,
                    Ssje:0,
                    TaxRate:0,
                    sortIndex: this.sort_data('self',item)
                  });
                }
                if(typeInsteadArr.indexOf(item)>-1){
                  rowListInstead.push({
                    TypeBig:'代收类费用',
                    XiaoXiang:item,
                    Dqsk:0,
                    Dqtk:0,
                    Yjcd:0,
                    Dqkpsr:0,
                    Bhsj:0,
                    Yjzzs:0,
                    Yszk:0,
                    Ystk:0,
                    Yssr:0,
                    Ssje:0,
                    TaxRate:0,
                    sortIndex: this.sort_data('instead',item)
                  });
                }
              }
            }
          let columnsPop = [
            { property:'TypeBig' },
            { property:'XiaoXiang' },
            { property:'Dqsk' },
            { property:'Dqtk' },
            { property:'Yjcd' },
            { property:'Dqkpsr' },
            { property:'Bhsj' },
            { property:'Yjzzs' },
            { property:'Yszk' },
            { property:'Ystk' },
            { property:'Yssr' },
            { property:'Ssje' }
          ]; //用于合计取数据
          rowListSelf = rowListSelf.sort((a,b)=> a.sortIndex - b.sortIndex ) ;
          this.d_data_self = rowListSelf;
          let param = {
            columns: columnsPop,
            data:rowListSelf
          };
          let totalNumSelf = this.getSummaries(param,'自收类合计');
          rowListSelf.push(totalNumSelf);
          rowListInstead = rowListInstead.sort((a,b)=> a.sortIndex - b.sortIndex ) ;
          this.d_data_instead =  rowListInstead;
          setTimeout(function () {
            let param2 = {
              columns: columnsPop,
              data:rowListInstead
            };
            let totalNumInstead = _this.getSummaries(param2,'代收类合计');
            rowListInstead.push(totalNumInstead);
          },500);
        }else {
          this.$Message.error(_data.data.Msg);
        }
          //------
          });
      },
    },
    created() {
      let billType = this.$store.state.app.billType;
      let selfType = billType.selfRent.concat(billType.self2);
      let insteadType = billType.instead;
      this.d_all_type_obj.self = selfType.map(item=>item.value);
      this.d_all_type_obj.agent = insteadType.map(item=>item.value);
      this.d_date_type = '日';
    },

    mounted(){
      this.pull_data()
    }
  }
</script>
